import { PropertyType } from '../propertyTypeEnum';
import { IAllAddresses, ICartAndActions, IServiceAddress } from '../types/buybox';

enum LookForType {
    cpid = PropertyType.cpid,
    lincNumber = PropertyType.lincNumber,
    rollNumber = PropertyType.rollNumber,
    titleNumber = PropertyType.titleNumber
}

const othersToVerifiedData = {
    [PropertyType.address]: 'addressVerified',
    [PropertyType.legalDescription]: 'legalDescriptionVerified',
    [PropertyType.legalDescriptionCondo]: 'legalDescriptionCondoVerified'
};

const getAddressVerifiedData = (serviceAddress: IServiceAddress, cartAndAction: ICartAndActions): IAllAddresses => {
    const { suite, addressNumber, streetName, quadrant, streetType } = cartAndAction;
    const { propertyType, lookFor, plan, unit, ldcPlan, block, lot } = cartAndAction;
    const legalDescriptionCondo = {
        plan: ldcPlan.value?.trim(),
        unit: unit.value?.trim(),
        isChecked: true
    };
    const legalDescription = {
        plan: plan.value?.trim(),
        block: block.value?.trim(),
        lot: lot.value?.trim(),
        isChecked: true
    };
    const address = {
        number: addressNumber.value?.trim(),
        quadrant: quadrant.value?.trim(),
        streetName: streetName.value?.trim(),
        streetType: streetType.value?.trim(),
        suite: suite.value?.trim(),
        isChecked: true
    };
    const possibles = {
        address,
        legalDescription,
        legalDescriptionCondo
    };
    const verifiedAddressData = {
        propertyType,
        serviceAddress,
        addressVerified: address,
        lookForVerified: {},
        legalDescriptionCondoVerified: {},
        legalDescriptionVerified: {},
        sdab: {},
        lcsab: {},
        relatedProduct: []
    };
    if (propertyType in LookForType) {
        verifiedAddressData.lookForVerified = {
            lookFor: lookFor.value?.trim(),
            isChecked: true
        };
    } else {
        verifiedAddressData[othersToVerifiedData[propertyType]] = possibles[PropertyType[propertyType]];
    }
    return verifiedAddressData;
};

export default getAddressVerifiedData;
